import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Radio } from 'antd';
import { DragOutlined, TableOutlined } from '@ant-design/icons';
import ActionBar from './components/ActionBar';
import Bookmark from './components/Bookmark';
import FileTable from './components/file-table/FileTable';
import ImageDragger from './components/ImageDragger';
import Events from './Events';
import ClearButton from './components/ClearButton';
import State from './State';

const Secondary = () => {
	const [showDragger, setShowDragger] = useState(State.files.length === 0);
	function onUploading() {
		setShowDragger(false);
	}
	useEffect(() => {
		Events.OnUploading(onUploading);
		return () => {
			Events.OnUploading(onUploading, true);
		};
	});
	return (
		<Fragment>
			<Row className="row-dragger">
				<Col sm={1} lg={3} xxl={4} />
				<Col sm={22} lg={18} xxl={16}>
					<div>
						<Radio.Group
							className="drag-list-radio"
							onChange={ev => {
								setShowDragger(ev.target.value === 'drag');
							}}
							value={showDragger ? 'drag' : 'table'}
						>
							<Radio.Button value="drag"><DragOutlined /></Radio.Button>
							<Radio.Button value="table"><TableOutlined /></Radio.Button>
						</Radio.Group>
						{ !showDragger && <ClearButton /> }
					</div>
					<FileTable
						className={showDragger ? 'filetable hidden' : 'filetable'}
						emptyText="Compressed files will list here."
					/>
					<ImageDragger visible={showDragger} />
					<br />
				</Col>
				<Col sm={1} lg={3} xxl={4} />
			</Row>
			<Bookmark />
			<ActionBar />
		</Fragment>
	);
};

export default Secondary;



// WEBPACK FOOTER //
// ./src/Secondary.js